import React, {ButtonHTMLAttributes} from "react";
import "./SvgButton.css"

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export default function SvgButton({onClick, children, ...props}: ButtonProps): React.JSX.Element {
    return (
        <button onClick={onClick} type="button" className={props.className ?? "svg-button"} {...props}>
            {children}
        </button>
    );
}